import styled from "styled-components";

/* Overlay */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  z-index: 9999;
  font-family: Inter, "Segoe UI", Roboto, Arial, sans-serif;
`;

/* Modal container */
export const ModalContainer = styled.div`
  width: auto;
  height: 100%;
  max-width: calc(100% - 48px);
  max-height: calc(680px - 48px);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(20, 20, 20, 0.25);
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  @media (max-width: 980px) {
    width: 95%;
    height: 100%;
    max-height: calc(100% - 48px);
    overflow: hidden;
    overflow-y: auto;
  }
`;

/* Header */
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px 32px;
  border-bottom: 1px solid #eee;

  h3 {
    margin: 0;
    font-size: 20px;
    color: #333;
    font-weight: 600;
  }

  button {
    background: transparent;
    border: none;
    font-size: 22px;
    color: #777;
    cursor: pointer;
  }
`;

/* Body layout */
export const Body = styled.div`
  display: flex;
  gap: 40px;
  padding: 24px 28px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

/* Columns */
export const ColLeft = styled.div`
  padding-top: 6px;

  @media (max-width: 980px) {
    order: 1;
  }
`;

export const ColCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  overflow-y: auto;
  max-height: 300px; /* define limite para rolar */
  padding-right: 8px; /* espaço pro scrollbar não sobrepor conteúdo */

  @media (max-width: 980px) {
    order: 2;
  }
`;


export const ColRight = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: 980px) {
    order: 3;
    width: 90%;
  }
`;

/* Labels e ícones */
export const SmallLabel = styled.span`
  color: #666;
  font-size: 13px;
  display: block;
  padding: 8px 8px 8px 8px;
`;

export const IconsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 2fr);
  gap: 10px;
  margin-bottom: 12px;
`;

export const IconButton = styled.button<{ selected?: boolean }>`
  height: 44px;
  border-radius: 8px;
  border: 1px solid ${({ selected }) => (selected ? "#ff7a4d" : "#eee")};
  background: ${({ selected }) =>
    selected
      ? "linear-gradient(90deg, rgba(255,122,77,0.06), rgba(255,122,77,0.03))"
      : "#fff"};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
  }
`;

export const Icon = styled.div`
  font-size: 18px;
`;

export const OutrosButton = styled.button`
  margin-top: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ff7a4d;
  background: transparent;
  color: #ff7a4d;
  cursor: pointer;
`;

/* Formulário */
export const Row = styled.div`
  display: flex;
  height: 56px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-starts;
  align-self: stretch;

  label {
    color: #666;
    font-size: 13px;
  }

  .input{
    display: flex;
    padding: 4px 0;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    flex: 1 0 0;
    height: 44px;
    width: 200px;
    border: none;
    border-bottom: 1px solid #EC6643;
    outline: none;
    font-size: 14px;
  }
`;

export const RowInline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const RowHalf = styled.div`
  display: flex;
  height: 56px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  label {
    color: #666;
    font-size: 13px;
  }

  input[type="date"] {
    height: 44px;
    width: 200px;
    padding: 4px 0;
    border: none;
    border-bottom: 1px solid #EC6643;
    outline: none;
    font-size: 14px;
  }
`;

export const Note = styled.span`
  margin-top: 8px;
  color: #999;
  font-size: 12px;
`;

/* Right column summary */
export const TotalTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  span {
    color: var(--Gray-gray-800, #40444C);

    /* text-paragraph-l */
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 156%; /* 28.08px */
  }

  strong {
    display: flex;
    width: 247px;
    padding: 8px 16px;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: var(--Primary-brand-50, #FDF0EC);
    color: var(--Gray-gray-800, #40444C);

    /* text-paragraph-l */
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 156%; /* 28.08px */
  }
`;

export const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  max-height: 320px; /* ou 60vh se quiser adaptar à tela */
  padding-right: 8px; /* evita o conteúdo colar na barra */
  margin-top: 8px;

  /* scrollbar estilizado opcional */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #E15533;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #FFE4DE;
  }
`;


export const Invest = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const InvestHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

export const InvestLabel = styled.span`
  color: #555;
  font-size: 13px;
`;

export const InvestValue = styled.span`
  border-bottom: 1px solid #6A717E;
  color: #333;
  font-weight: 600;
  font-size: 13px;
  justify-content: flex-start;
`;

export const Bar = styled.div`
  display: flex;
  width: 354px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 25px;
  border-radius: 0px;
  overflow: hidden;
  z-index: 9;
`;

export const BarFill = styled.div<{ width: string }>`
  height: 100%;
  width: ${({ width }) => width};
  background: linear-gradient(90deg, #ff7a4d, #ffb18f);
  border-radius: 8px;
  transition: width 0.4s ease;
`;

export const InvestTotal = styled.span`
  margin-top: 2px;
  font-size: 12px;
  color: #6A717E;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  width: 100%;
`;

/* Footer */
export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px 28px;
  border-top: 1px solid #eee;
`;

export const BtnCancel = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  border: 1px solid #ff7a4d;
  background: transparent;
  color: #ff7a4d;
  cursor: pointer;
`;

export const BtnExcluir = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  border: 1px solid var(--Semantic-Error-error-500, #F94361);
  background: transparent;
  color: var(--Semantic-Error-error-500, #F94361);
  cursor: pointer;
`;

export const BtnCreate = styled.button`
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  background: linear-gradient(90deg, #ff7a4d, #ff8c5b);
  color: white;
  cursor: pointer;
`;
